import React, { useState } from "react"
import ArrowIcon from "../assets/images/ArrowIconWhite.svg"
import PhoneInput from "react-phone-input-2"
import "react-phone-input-2/lib/style.css"
import { isCustomEnrollId, isValidEmail, prescriptionContents } from "../utilities"
import { sendOtpService } from "../services/apiServices"
import { LoadingOutlined } from "@ant-design/icons"
import { useParams } from "react-router-dom/cjs/react-router-dom.min"
import TickIcon from "../assets/images/TickIconGreen.svg"
import { Modal } from "antd"
import { MdClose } from "react-icons/md"

function TopSectionPrescriptionAudit({ setOtpErrorMessage, isEmail, setIsEmail, formValue, setFormValue, disabledForm, setUserId, setDisabledForm, metarxDetails }) {
  const [loading, setLoading] = useState(false)
  const [uploadMessage, setUploadMessage] = useState("")
  const [openPrescriptionModal, setOpenPrescriptionModal] = useState(false)

  const { metarxId } = useParams()

  const sendOtp = () => {
    setLoading(true)
    const payload = isEmail ? { email: formValue, metarxId: metarxId } : { mobileNumber: formValue.substring(2), metarxId: metarxId }
    sendOtpService(payload)
      .then((response) => {
        if (response.hasUploaded) {
          setUploadMessage(response.message)
          setOpenPrescriptionModal(true)
        } else {
          setDisabledForm(true)
          setUserId(response.userId)
        }
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
        if (error.response?.data?.message) {
          setOtpErrorMessage(error.response.data.message)
        }
        setDisabledForm(true)
      })
  }

  const handleSwitch = () => {
    setFormValue("")
    setIsEmail(!isEmail)
  }

  const validateForm = () => {
    return disabledForm || (isEmail ? !formValue || !formValue.trim() || !isValidEmail(formValue) : !formValue || formValue.length < 12)
  }


  const handleClose = () => {
    window.location.reload()
    setOpenPrescriptionModal(false)
  }

  return (
    <section className="topSection prescription-audit-top-section">
      <article>
        <h1>{isCustomEnrollId(metarxId) ? prescriptionContents.enrollNow : prescriptionContents.prescriptionAudit}</h1>
        <p>{isCustomEnrollId(metarxId) ? prescriptionContents.enrollNowDesc : prescriptionContents.prescriptionAuditDesc}</p>
        <div className="form-container" style={disabledForm ? { cursor: "no-drop", opacity: 0.5 } : {}}>
          <div className="prescription-audit-form">
            {!isEmail ? (
              <div style={{ position: "relative" }} className="mobile-form-controls">
                <PhoneInput country={"in"} countryCodeEditable={false} disableDropdown={true} value={formValue} onChange={setFormValue} placeholder="Enter mobile number" />
                {!formValue && <span className="place-holder-text">Enter mobile number</span>}
              </div>
            ) : (
              <input type="email" placeholder="Enter email address" value={formValue} onChange={(ev) => setFormValue(ev.target.value)} className="form-controls" />
            )}
            <div className="or-separator">
              <span>Or</span>
            </div>
            <button disabled={disabledForm} onClick={handleSwitch} className="link-button">
              {isEmail ? "Use mobile number instead" : "Use email instead"}
            </button>
          </div>
          <button onClick={sendOtp} disabled={validateForm()} className="green-button">
            Continue to verify {loading ? <LoadingOutlined className="ml-16" /> : <img src={ArrowIcon} alt />}
          </button>
        </div>
        {disabledForm && (
          <span onClick={() => setDisabledForm(false)} className="reset-from">
            Reset
          </span>
        )}
      </article>

      <Modal title={""} footer={null} visible={openPrescriptionModal} onOk={handleClose} onCancel={handleClose}
        closeIcon={<MdClose />} className="bookingModal" width={370} centered>
        <section className="thankYouMessage">
          <img src={TickIcon} alt="" />
          <h2>{uploadMessage}</h2>
        </section>
      </Modal>
    </section>
  )
}

export default TopSectionPrescriptionAudit
